import { useRoutes } from "react-router-dom";
import PositionListPage from "../position/position-list-page";
import EmailListPage from "../Templates/email-list-page";
import { paths } from "./path";
import InterviewEvaluation from "../interview/interview-evaluation";
import SettingPage from "../settings/setting-page";
import VideoInterviewCard from "../intropages/video-intro";
import { AddPosition } from "../position/add-position";
import TemplatesPage from "../position/TemplatesPage";
import InterviewCompletion from "../intropages/interview-finish-page";
import InterviewDetails from "../position/interview-details";
import PublicInterviewEvaluation from "../public-interview";

export function Router() {
  return useRoutes([
    {
      children: [
        { path: paths.PositionListPage, element: <PositionListPage /> },
        { path: paths.EmailListPage, element: <EmailListPage /> },
        { path: paths.evaluationScreen, element: <InterviewEvaluation /> },
        { path: paths.publicInterview, element: <PublicInterviewEvaluation /> },
        { path: paths.settings, element: <SettingPage /> },
        { path: paths.interview, element: <VideoInterviewCard /> },
        { path: paths.addPosition, element: <AddPosition /> },
        { path: paths.templates, element: <TemplatesPage /> },
        { path: paths.finishInterview, element: <InterviewCompletion /> },
        { path: paths.intevriewDetails, element: <InterviewDetails /> },
      ],
    },
  ]);
}
